export default{
	lang:{
		title: '车辆接线图查询',
		language: '语言',
		brand: "品牌",
		carName: "车型",
		searchMC: "系统名称",
		searchMS: "系统描述",
		jumper: "跳线ID",
		buuton1: "查询",
		desOption:['电池包检测','车上压缩机','车下压缩机'],
		report:{
			shebei1: '由',
			shebei2: '检测设备提供',
			oneTitle: '检测结果',
			ver: '未设置车牌号',
			vin: '车架号(VIN)',
			bianhao: '报告编号',
			jcTime: '检测时间',
			bms: 'BMS 检测结果',
			tips: '提示',
			tipText: '“不支持”表示“电池包检测”不支持读取该项数据，可尝试选择全车诊断底下的BMS（电池管理系统）读取数据流查看。',
			soc: 'SOC 剩余电量',
			soh: 'SOH 电池健康度',
			Vname1: '总电压',
			Vname2: '电池组充电放电次数',
			Vname3: '最高单体电池电压',
			Vname4: '最高单体电池温度',
			Vname5: '最低单体电池电压',
			Vname6: '最低单体电池温度',
			Vname7: '压差',
			Vname8: '绝缘电阻值',
			bms: 'BMS检测详情',
			tab1: '检测项目',
			tab2: '检测结果',
			tab3: '单位',
			dtdy: '单体电池电压',
			max: '最高',
			min: '最低',
			dcwd: '单体电池温度',
			shengcheng: '生成PDF',
			jcsb: '检测设备',
			sbbh: '设备编号',
		}
	}
}